import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import {
  getPaginatedNodes,
  getPaginationTotalResults,
  toPagination,
} from './utils';
import { PaginationSort, VulnerabilityFilterInput } from '../gql/graphql';

export const GET_VULNERABILITY_LIST = graphql(`
  query getVulnerabilityList(
    $pagination: PaginationRequest
    $filters: VulnerabilityFilterInput
    $sort: PaginationSort
  ) {
    vulnerabilities(pagination: $pagination, filters: $filters, sort: $sort) {
      edges {
        node {
          uuid
          cve
          type
          publishDate
          updateDate
          score
          access
          complexity
          authentication
          conf
          integ
          source
        }
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);
export interface IUseVulnerabilityListQueryArg {
  pageNumber: number;
  pageSize: number;
  sort?: PaginationSort;
  filters?: VulnerabilityFilterInput;
}
export function useVulnerabilityListQuery({
  pageNumber,
  pageSize,
  sort,
  filters,
}: IUseVulnerabilityListQueryArg) {
  const { loading, data, error } = useQuery(GET_VULNERABILITY_LIST, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort,
      filters: {
        ...filters,
      },
    },
  });
  const { vulnerabilities, totalVulnerabilities } = useMemo(() => {
    if (loading) {
      return {
        vulnerabilities: [],
        totalVulnerabilities: 0,
      };
    }
    return {
      vulnerabilities: getPaginatedNodes(data?.vulnerabilities),
      totalVulnerabilities:
        getPaginationTotalResults(data?.vulnerabilities) ?? 0,
    };
  }, [data, loading]);

  return {
    loading,
    error,
    data,
    vulnerabilities,
    totalVulnerabilities,
  };
}
